import React, { Component } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import apiCall from '../../utils/apiCall';
import { toast } from 'react-toastify';
import HeaderNav from '../common/HeaderNav';

const theme = createTheme({
  palette: {
    secondary: {
      main: "#000040"
    }
  }
});

class Registration extends Component {
  state = {
    registrationSuccess: false,
    passwordError: "",
    confirmPasswordError: "",
    showPassword: false,
    showConfirmPassword: false
  };

  validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  handleClickShowPassword = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  };

  handleClickShowConfirmPassword = () => {
    this.setState(prevState => ({
      showConfirmPassword: !prevState.showConfirmPassword
    }));
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const password = data.get('password');
    const confirmPassword = data.get('confirm_password');

    if (!this.validatePassword(password)) {
      this.setState({ passwordError: "Password must be at least 8 characters long and contain both letters and numbers. Special characters (@$!%*?&) are allowed." });
      return;
    } else {
      this.setState({ passwordError: "" });
    }

    if (password !== confirmPassword) {
      this.setState({ confirmPasswordError: "Passwords do not match." });
      return;
    } else {
      this.setState({ confirmPasswordError: "" });
    }

    const { result } = await apiCall('REACT_APP_SIGNUP_URL', 'POST', {
      firstName: data.get('firstName'),
      lastName: data.get('lastName'),
      email: data.get('email'),
      password: password,
      confirm_password: confirmPassword,
    });

    if (result && result.success && result.status) {
      toast.success(result.msg || "SignUp Success");
      window.location.href = '/login';
    }
  };

  render() {
    return (
      <React.Fragment>
        <HeaderNav activeTabName="signUp" />
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box sx={{ marginTop: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Avatar sx={{ m: 1, bgcolor: this.state.registrationSuccess ? 'success.main' : '#000040' }}>
                {this.state.registrationSuccess ? <LockOpenOutlinedIcon /> : <LockOutlinedIcon />}
              </Avatar>
              <Typography component="h1" variant="h5">
                {this.state.registrationSuccess ? 'Registration Success' : 'Registration'}
              </Typography>
              <Box component="form" onSubmit={this.handleSubmit} noValidate sx={{ mt: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs>
                    <TextField color="secondary" margin="normal" required fullWidth id="firstName" label="First Name" name="firstName" autoComplete="firstName" autoFocus size='small' />
                  </Grid>
                  <Grid item xs>
                    <TextField color="secondary" margin="normal" required fullWidth id="lastName" label="Last Name" name="lastName" autoComplete="lastName" size='small' />
                  </Grid>
                </Grid>
                <TextField color="secondary" margin="normal" required fullWidth id="email" label="Email Address" name="email" autoComplete="email" size='small' />
                <TextField 
                  color="secondary" 
                  margin="normal" 
                  required 
                  fullWidth 
                  name="password" 
                  label="Password" 
                  type={this.state.showPassword ? 'text' : 'password'} 
                  id="password" 
                  autoComplete="current-password" 
                  size='small' 
                  error={!!this.state.passwordError} 
                  helperText={this.state.passwordError}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}
                          edge="end"
                        >
                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField 
                  color="secondary" 
                  margin="normal" 
                  required 
                  fullWidth 
                  name="confirm_password" 
                  label="Confirm Password" 
                  type={this.state.showConfirmPassword ? 'text' : 'password'} 
                  id="confirm_password" 
                  autoComplete="current-password" 
                  size='small' 
                  error={!!this.state.confirmPasswordError} 
                  helperText={this.state.confirmPasswordError}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle confirm password visibility"
                          onClick={this.handleClickShowConfirmPassword}
                          onMouseDown={this.handleMouseDownPassword}
                          edge="end"
                        >
                          {this.state.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button className='signup-btn' type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2, bgcolor: "#000040" }}>Sign Up</Button>
                <Grid container justifyContent='center'>
                  <Grid item>
                    <Link className="signup-links" href="/login" variant="body2">
                      "Already have an account? Log In"
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Container>
        </ThemeProvider>
      </React.Fragment>
    );
  }
}

export default Registration;
